import { render, staticRenderFns } from "./SeriesVideoManagement.vue?vue&type=template&id=69f413b1&scoped=true&"
import script from "./SeriesVideoManagement.vue?vue&type=script&lang=js&"
export * from "./SeriesVideoManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69f413b1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69f413b1')) {
      api.createRecord('69f413b1', component.options)
    } else {
      api.reload('69f413b1', component.options)
    }
    module.hot.accept("./SeriesVideoManagement.vue?vue&type=template&id=69f413b1&scoped=true&", function () {
      api.rerender('69f413b1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/Admin/Series/SeriesVideoManagement.vue"
export default component.exports